import React, { useEffect, useState } from 'react'

import { NativeSelect, InputBase, Checkbox, Button  } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  inputDark:{
    borderBottom:'1px solid white',
    color:'white',
    fontSize:20,
    marginBottom:16,
  },
  inputLight:{
    borderBottom:'1px solid black',
    color:'black',
    fontSize:20,
    marginBottom:16,
  },
  selectDark: {
    color:'white'
  },
  selectLight: {
    color:'black'
  }
});

const Add = props => {
  const classes = useStyles()

  const [subject, setSubject] = useState('')
  const [subjectList, setSubjectList] = useState([])
  const [pyt, setPyt] = useState('')
  const [answers, setAnswers] = useState([])
  //const [auth, setAuth] = useState('');


  useEffect(async () => {
    const res = await fetch(`${document.location.origin}/.netlify/functions/subjects`)
    const res_json = await res.json()
    res_json.unshift({
      term: 0,
      subject: 'Wybierz przedmiot'
    })
    setSubjectList(res_json)
    
  },[])

  const submitAnswers = async () => {
    if(subject && subject !== "Wybierz przedmiot"){
      const body = {
        subject:subject,
        question:pyt,
        term:subjectList.find(x => x.subject === subject).term,
        answers: answers,
      }
      const config = {
        method:'POST',
      //headers:{
      //  "Authorization":`Bearer ${btoa(auth)}`
      //},
        body:JSON.stringify(body)
      }
      
      console.log(JSON.stringify(config,null,4))
      console.log(`${document.location.origin}/.netlify/functions/add`)
      const req = await fetch(`${document.location.origin}/.netlify/functions/add`, config)
      const json = await req.json();
      alert(json.msg)
    } else {
      alert('Wybierz przedmiot')
    }
  }

  return (
    <div>
      <div style={{
        width:'100%',
        marginTop:'25px'
      }}>
        <NativeSelect
          classes={{
            root:props.isDark ? classes.inputDark : classes.inputLight,
            icon:props.isDark ? classes.selectDark : classes.selectLight
          }}
          style={{
            width:'100%',
          }}
          value={subject}
          disableUnderline={true}
          onChange={async (event) => {
            let { value } = event.target
            setSubject(value)
          }}
        >
          {subjectList.map(y => <option key={y.subject} value={y.subject} style={{color:'black'}}>[{y.term}] {y.subject}</option>)}
        </NativeSelect>
        <div>
          <span style={{color: props.isDark ? 'white' : 'black'}}>Pytanie</span>
          <br></br>
          <InputBase
            fullWidth
            multiline
            value={pyt}
            onChange={(e) => setPyt(e.target.value)}
            label="Pytanie"
            style={{
                borderBottom: props.isDark ? '1px solid white' : '1px solid black',
                color: props.isDark ? 'white' : 'black'
            }}
          />
          <div style={{
            display:'flex',
            justifyContent:'space-evenly',
            marginTop:20
          }}>
            <Button style={{background: props.isDark ? "rgba(255,255,255,0.1)" : "#39767C", color:'white'}} onClick={() => {
              let f = [...answers]
              f.push({
                text:'',
                correct:false
              })
              setAnswers(f)
            }}>Dodaj kolejną Odpowiedź</Button>
            
            <Button style={{background: props.isDark ? "rgba(255,255,255,0.1)" : "#39767C", color:'white'}} disabled={answers.length === 0} onClick={() => {
              let f = [...answers]
              f.pop()
              setAnswers(f)
            }}>Usuń ostatnią Odpowiedź</Button>
          </div>
          {answers.map((x, index) => {
            return (
            <div>
              <p style={{color: props.isDark ? 'white' : 'black'}}>Odpowiedź {index + 1}</p>
              <div style={{
                display:'flex',

              }}>
                <InputBase
                  fullWidth
                  multiline
                  value={x.text}
                  onChange={(e) => {
                    let f = [...answers]
                    f[index] = {
                      text:e.target.value,
                      correct:false
                    }
                    setAnswers(f)
                  }}
                  label={`Odpowiedz ${index + 1}`}
                  style={{
                    borderBottom: props.isDark ? '1px solid white' : '1px solid black',
                    color: props.isDark ? 'white' : 'black'
                  }}
                />
                <Checkbox
                  checked={x.correct}
                  style={{color: props.isDark ? 'white' : 'black'}}
                  disableRipple
                  color="default"
                  onChange={(e) => {
                    let f = [...answers]
                    f[index].correct = e.target.checked
                    setAnswers(f)
                  }}
                />

              </div>
            </div>
            )
          })}
          <div style={{
            display:'flex',
            justifyContent:'space-evenly',
            marginTop:20
          }}>

            <Button style={{background: props.isDark ? "rgba(255,255,255,0.1)" : "#39767C", color:'white'}} onClick={() => submitAnswers()}>Prześlij</Button>
          </div>
          {/* 
            Autoryzacja
            <br></br>
            <InputBase
              fullWidth
              value={auth}
              onChange={(e) => {
                setAuth(e.target.value.trim())
              }}
              label={`Auth`}
              style={{
                  borderBottom:'1px solid white',
                  color:'white'
              }}
            />
            */}
        </div>
      </div>
    </div>
  );
}

export default Add